import React, {PropsWithChildren} from 'react';

const PageContent: React.FC<
  PropsWithChildren & {fullscreen?: boolean; noPadding?: boolean}
> = ({children, fullscreen = true, noPadding = false}) => {
  return (
    <div className="page">
      <div
        className={`pageContent ${fullscreen ? '' : 'noFullscreen'} ${
          noPadding ? 'noPadding' : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default PageContent;
